<!-- SMT生产周期必看弹框 -->
<template>
  <div class="smt-deltime-mustsee">
    <BaseTextButton @click="isShow = true">
      {{ text }}
    </BaseTextButton>

    <el-dialog
      width="600px"
      top="100px"
      title="生产周期说明"
      class="smt-deltime-dialog"
      append-to-body
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible="isShow"
      @close="isShow = false"
    >
      <div>
        <div class="smt-deltime-dialog__item">
          <h3>物料齐套定义</h3>
          <p>齐料→QC入库分拣与焊盘核对<span>（1-2天）</span>→生产开始</p>
        </div>
        <div class="smt-deltime-dialog__item">
          <h3>订单生产周期起算规则</h3>
          <p>
            <img
              src="@@/assets/img/icons/clock.png"
              class="chip-num-icon"
            />
            <span>16:00前</span>焊盘核对完成→当即开始计算
          </p>
          <p>
            <img
              src="@@/assets/img/icons/clock.png"
              class="chip-num-icon"
            />
            <span>16:00后</span>焊盘核对完成→次日8:00开始计算
          </p>
        </div>
        <div class="smt-deltime-dialog__item">
          <h3>样品图确认要求</h3>
          <p>● <span>4小时</span>内确认&nbsp;|&nbsp;逾期则交期顺延</p>
          <p>
            <img
              src="@@/assets/img/icons/clock.png"
              class="chip-num-icon"
            />
            <span>16:00前</span>确认无误→当即开始计算交期
          </p>
          <p>
            <img
              src="@@/assets/img/icons/clock.png"
              class="chip-num-icon"
            />
            <span>16:00后</span>→<span>次日8:00</span>开始计算交期
          </p>
        </div>
        <div class="smt-deltime-dialog__item">
          <h3>资料确认截止时间</h3>
          <p>● 齐料前48小时完成核对</p>
          <span class="gray"
            >（如齐料后更新文件或确认工程问题，延迟交期将顺延）</span
          >
        </div>
        <div class="smt-deltime-dialog__item">
          <h3>加急与特殊工艺</h3>
          <p>● 加急订单：协商交期</p>
          <p>
            ● 特殊工艺<span class="gray"
              >（需开立DIP焊接治具、压接治具、涂三防漆、烧录、功能测试、组装等特殊工艺）</span
            >：协商交期
          </p>
          <p>
            ● 大批量<span class="gray"
              >（若大于2000套或插件总焊点数大于100000点）</span
            >：联系客服提供准确交期
          </p>
        </div>
        <div class="smt-deltime-dialog__item">
          <h3>通用规则</h3>
          <p>
            ● 仅工作日生产<span class="gray"
              >（周日和法定节假日工厂不生产）</span
            >
          </p>
          <p>
            ● 特殊情况见公告<span class="gray">（如遇集中停电或疫情等）</span>
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "SMT生产周期必看",
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.smt-deltime-mustsee {
  .base-text-button:hover {
    background-color: #fff;
  }
}
.chip-num-icon{
  width: 16px;
  height: 16px;
  margin-right: 5px;
}
.smt-deltime-dialog ::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid $--border-color-base;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  .el-dialog__body {
    padding: 20px 30px 30px;
  }
  .el-dialog__title {
    font-size: 16px;
    font-weight: 700;
    color: $--color-text-primary;
  }

  .smt-deltime-dialog__item {
    margin-bottom: 20px;
    font-size: 14px;
    h3 {
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 8px;
    }
    p {
      font-size: 13px;
      font-weight: 400;
      line-height: 20px;
      > span {
        color: #e6a23c;
      }
    }
    .gray {
      color: #999999 !important;
    }
  }
}
</style>
